module.exports = __webpack_public_path__ + "static/media/09-popup.96e95959.png";